import { Alert, Box, Grow, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import ButtonMapMenuClose from "assets/icons/btn_mapmenu_close.svg";
import IconMySetting from "assets/icons/default_condition/ic_mysetting.svg";
import { BldConditionButtons } from "components/Parts/Molecules/EstateFilterDialog/components/BldConditionButtons";
import { CompletionYMSlider } from "components/Parts/Molecules/EstateFilterDialog/components/CompletionYMSlider";
import { EstateLabelButtons } from "components/Parts/Molecules/EstateFilterDialog/components/EstateLabelButtons";
import { EstatePriceSlider } from "components/Parts/Molecules/EstateFilterDialog/components/EstatePriceSlider";
import { OtherConditionButton } from "components/Parts/Molecules/EstateFilterDialog/components/OtherConditionButton";
import { PurposeSummaryBButton } from "components/Parts/Molecules/EstateFilterDialog/components/PurposeSummaryBButton";
import { RoomsSlider } from "components/Parts/Molecules/EstateFilterDialog/components/RoomsSlider";
import { SquareAreaOfMansionSlider } from "components/Parts/Molecules/EstateFilterDialog/components/SquareAreaOfMansionSlider";
import { StructureSummaryButton } from "components/Parts/Molecules/EstateFilterDialog/components/StructureSummaryButton";
import { TsuboAreaSlider } from "components/Parts/Molecules/EstateFilterDialog/components/TsuboAreaSlider";
import { ProgressBackdrop } from "components/Parts/Molecules/ProgressBackdrop";
import React from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import { EstateTypeButtons } from "../../Molecules/EstateFilterDialog/components/EstateTypeButtons";
import { CitiesSelector } from "../SwitchAreaDialog/subComponents/CitiesSelector";
import styles from "./DefaultConditionInputDialog.module.scss";
import { useDefaultConditionInputDialogHooks } from "./hooks";
import { DefaultConditionInputDialogProps } from "./interfaces";

const idPrefix = "default-condition-input-dialog";

export const DefaultConditionInputDialog = React.memo(
  (props: DefaultConditionInputDialogProps) => {
    const {
      sliderTheme,

      titRef,
      boxRef,

      busy,

      citiesErrorMessage,
      selectableCities,
      selectedCityCodes,

      filterConditions,
      estateTypes,
      bldConditionSelections,
      structureSummaries,
      purposeSummaryBs,

      formattedEstatePriceFrom,
      formattedEstatePriceTo,

      formattedTsuboAreaFrom,
      formattedTsuboAreaTo,

      tsuboAreaFromIndex,
      tsuboAreaToIndex,

      formattedSquareAreaOfMansionFrom,
      formattedSquareAreaOfMansionTo,

      squareAreaOfMansionFromIndex,
      squareAreaOfMansionToIndex,

      formattedCompletionYMFrom,
      formattedCompletionYMTo,

      completionYMFromIndex,
      completionYMToIndex,

      formattedRoomsFrom,
      formattedRoomsTo,

      roomsFromIndex,
      roomsToIndex,

      priceLabel,
      tsuboLabel,

      // resetButtonOn,
      okButtonOn,

      isAdministrator,
      isPricingAvailable,

      onCitiesClick,

      onEstateTypesChange,

      onPriceLabelChange,
      onTsuboLabelChange,

      onEstatePriceChange,

      onTsuboAreaChange,
      onSquareAreaOfMansionChange,

      onCompletionYMIndexChange,

      onRoomsChange,

      onBldConditionSelectionsChange,

      onPetOkChange,
      onFlatChange,
      onForRentChange,
      onExceptForRentChange,
      onMyCompanyOnlyChange,
      onVenderOnlyChange,
      onStructureSummariesChange,
      onPurposeSummaryBsChange,

      // onResetButtonClick,
      onOkAndExecuteButtonClick,
      onBackPaperClick
    } = useDefaultConditionInputDialogHooks(props);

    return (
      <Dialog
        open={props.open}
        aria-labelledby={`${idPrefix}-title`}
        aria-describedby={`${idPrefix}-description`}
        onClose={(e, reason) =>
          props.onClose && reason !== "escapeKeyDown" && props.onClose()
        }
        slotProps={{
          backdrop: { className: styles.backdrop },
          paper: { onClick: onBackPaperClick }
        }}
        classes={{
          scrollPaper: styles.paperScrollPaper,
          paper: styles.paper,
          container: styles.container
        }}
        slots={{ transition: Grow }}
        transitionDuration={{ appear: 200, enter: 200, exit: 100 }}
      >
        <ProgressBackdrop
          open={busy || props.busy || false}
          sx={{
            zIndex: 50000
          }}
        />
        <Box className={`${styles.popup_map} twbasic01 ${styles.on}`}>
          <Box className={styles.scroll}>
            <Box className={styles.tit} ref={titRef}>
              <Box component="span">
                <img src={IconMySetting} alt="設定" />
              </Box>
              <Box className={styles.btn_sub_close} onClick={props.onClose}>
                <img src={ButtonMapMenuClose} alt="閉じる" />
                <Typography component="b">閉じる</Typography>
              </Box>
            </Box>
            <Box className={styles.box} ref={boxRef}>
              <Box className={styles.box2}>
                <Box className={styles.ovfl}>
                  <Box className={styles.top_caption}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        初期表示設定
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.estate_type_caption}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        物件種別
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.estate_type}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <EstateTypeButtons
                              estateTypesMaster={estateTypes}
                              estateTypes={filterConditions.estateTypes}
                              onEstateTypesChange={onEstateTypesChange}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.label_caption}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        ラベル
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.label}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <EstateLabelButtons
                              priceLabel={priceLabel}
                              tsuboLabel={tsuboLabel}
                              onPriceLabelChange={onPriceLabelChange}
                              onTsuboLabelChange={onTsuboLabelChange}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.filter_caption}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        絞込条件
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.popup_map_filter}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func_v2} ${styles.slider_v2} ${
                          styles.price
                        } ${
                          isMobileOnly
                            ? styles.isMobileOnly
                            : isMobile
                              ? styles.isMobile
                              : ""
                        }`}
                      >
                        <EstatePriceSlider
                          sliderTheme={sliderTheme}
                          id="price-slider"
                          styles={styles}
                          valueFrom={filterConditions.estatePriceFrom}
                          valueTo={filterConditions.estatePriceTo}
                          formattedEstatePriceFrom={formattedEstatePriceFrom}
                          formattedEstatePriceTo={formattedEstatePriceTo}
                          onChange={onEstatePriceChange}
                        />
                      </Box>
                      <Box
                        className={`${styles.func_v2} ${styles.slider_v2} ${
                          styles.size
                        } ${
                          isMobileOnly
                            ? styles.isMobileOnly
                            : isMobile
                              ? styles.isMobile
                              : ""
                        }`}
                      >
                        <TsuboAreaSlider
                          sliderTheme={sliderTheme}
                          id="tsubo-area-slider"
                          styles={styles}
                          valueFrom={tsuboAreaFromIndex}
                          valueTo={tsuboAreaToIndex}
                          formattedTsuboAreaFrom={formattedTsuboAreaFrom}
                          formattedTsuboAreaTo={formattedTsuboAreaTo}
                          onChange={onTsuboAreaChange}
                        />
                      </Box>
                      <Box
                        className={`${styles.func_v2} ${styles.slider_v2} ${
                          styles.age
                        } ${
                          isMobileOnly
                            ? styles.isMobileOnly
                            : isMobile
                              ? styles.isMobile
                              : ""
                        }`}
                      >
                        <CompletionYMSlider
                          sliderTheme={sliderTheme}
                          id="completion-ym-slider"
                          styles={styles}
                          valueFrom={completionYMFromIndex}
                          valueTo={completionYMToIndex}
                          formattedCompletionYMFrom={formattedCompletionYMFrom}
                          formattedCompletionYMTo={formattedCompletionYMTo}
                          onChange={onCompletionYMIndexChange}
                        />
                      </Box>
                      <Box
                        className={`${styles.func_v2} ${styles.slider_v2} ${
                          styles.size
                        } ${
                          isMobileOnly
                            ? styles.isMobileOnly
                            : isMobile
                              ? styles.isMobile
                              : ""
                        }`}
                      >
                        <RoomsSlider
                          sliderTheme={sliderTheme}
                          id="rooms-slider"
                          styles={styles}
                          valueFrom={roomsFromIndex}
                          valueTo={roomsToIndex}
                          formattedRoomsFrom={formattedRoomsFrom}
                          formattedRoomsTo={formattedRoomsTo}
                          onChange={onRoomsChange}
                        />
                      </Box>
                      <Box
                        className={`${styles.func_v2} ${styles.slider_v2} ${
                          styles.size
                        } ${
                          isMobileOnly
                            ? styles.isMobileOnly
                            : isMobile
                              ? styles.isMobile
                              : ""
                        }`}
                      >
                        <SquareAreaOfMansionSlider
                          sliderTheme={sliderTheme}
                          id="square-area-of-mansion-slider"
                          styles={styles}
                          valueFrom={squareAreaOfMansionFromIndex}
                          valueTo={squareAreaOfMansionToIndex}
                          formattedSquareAreaOfMansionFrom={
                            formattedSquareAreaOfMansionFrom
                          }
                          formattedSquareAreaOfMansionTo={
                            formattedSquareAreaOfMansionTo
                          }
                          onChange={onSquareAreaOfMansionChange}
                        />
                      </Box>
                    </Box>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.rule}`}
                      >
                        <Box className={styles.tit}>
                          <Box component="span">建築条件</Box>
                        </Box>
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <BldConditionButtons
                              bldConditionSelectionsMaster={
                                bldConditionSelections
                              }
                              bldConditionSelections={
                                filterConditions.bldConditionSelections
                              }
                              onBldConditionSelectionsChange={
                                onBldConditionSelectionsChange
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        <Box className={styles.tit}>
                          <Box component="span">条件選択</Box>
                        </Box>
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <OtherConditionButton
                              petOk={filterConditions.petOk}
                              flat={filterConditions.flat}
                              forRent={filterConditions.forRent}
                              exceptForRent={filterConditions.exceptForRent}
                              myCompanyOnly={
                                filterConditions.companyRecNo !== 0
                              }
                              venderOnly={filterConditions.venderOnly}
                              isAdministrator={isAdministrator}
                              isPricingAvailable={isPricingAvailable}
                              onPetOkChange={onPetOkChange}
                              onFlatChange={onFlatChange}
                              onForRentChange={onForRentChange}
                              onExceptForRentChange={onExceptForRentChange}
                              onMyCompanyOnlyChange={onMyCompanyOnlyChange}
                              onVenderOnlyChange={onVenderOnlyChange}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        <Box className={styles.tit}>
                          <Box component="span">構造</Box>
                        </Box>
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <StructureSummaryButton
                              structureSummariesMaster={structureSummaries}
                              structureSummaries={
                                filterConditions.structureSummaries
                              }
                              onStructureSummariesChange={
                                onStructureSummariesChange
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        <Box className={styles.tit}>
                          <Box component="span">事業用</Box>
                        </Box>
                        <Box className={styles.dtl}>
                          <Box className={styles.setting}>
                            <PurposeSummaryBButton
                              purposeSummaryBsMaster={purposeSummaryBs}
                              purposeSummaryBs={
                                filterConditions.purposeSummaryBs
                              }
                              onPurposeSummaryBsChange={
                                onPurposeSummaryBsChange
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.area_caption}>
                    <Box className={styles.ctt}>
                      <Box
                        className={`${styles.func} ${styles.select} ${styles.other}`}
                      >
                        市区町村
                      </Box>
                    </Box>
                  </Box>
                  <Box className={styles.popup_map_areaselect}>
                    <Box className={styles.ctt}>
                      <Box className={styles.dtl}>
                        <Box className={styles.area}>
                          <CitiesSelector
                            selectableCities={selectableCities}
                            selectedCityCodes={selectedCityCodes}
                            onCitiesClick={onCitiesClick}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box className={`${styles.popup_map_btn} ${styles.btn_3ko}`}>
                {citiesErrorMessage ? (
                  <Alert className={styles.alert} color="error">
                    {citiesErrorMessage}
                  </Alert>
                ) : null}
                <Box
                  className={`${styles.btn} ${styles.cancel}`}
                  onClick={props.onClose}
                >
                  閉じる
                </Box>
                {/* <Box
                  className={`${styles.btn} ${styles.reset} ${
                    resetButtonOn ? styles.on : styles.off
                  }`}
                  onClick={onResetButtonClick}
                >
                  リセット
                </Box> */}
                <Box
                  className={`${styles.btn} ${styles.arrow2} ${
                    okButtonOn ? styles.on : styles.off
                  }`}
                  onClick={onOkAndExecuteButtonClick}
                >
                  設定する
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    );
  }
);
